import { useFormContext, useWatch } from 'react-hook-form';
import { ConditionType, TriggerType } from 'models/automation/Triggers';
import {
  EVENT_TYPE_TO_CONDITIONS_MAPPING,
  TIME_CONDITION_TO_CONDITIONS_MAPPING,
} from '../../TriggersTab.constants';
import { TriggerAddEditModalFormValues } from '../TriggerAddEditModal.schema';

const useAvailableConditions = (): ConditionType[] => {
  const { control } = useFormContext<TriggerAddEditModalFormValues>();
  const triggerType = useWatch({ control, name: 'triggerType' });
  const eventType = useWatch({ control, name: 'eventType' });
  const timeConditionType = useWatch({ control, name: 'timeCondition.type' });

  if (triggerType === TriggerType.TIME_BASED && timeConditionType) {
    return TIME_CONDITION_TO_CONDITIONS_MAPPING[timeConditionType];
  }

  if (triggerType !== TriggerType.TIME_BASED && eventType) {
    return EVENT_TYPE_TO_CONDITIONS_MAPPING[eventType] ?? [];
  }

  return [];
};

export default useAvailableConditions;
